import React, { PureComponent } from 'react';

import loading from './assets/loadingspinner.png';
import config from './Loading.component.config';
import './Loading.less';

class Loading extends PureComponent {
  render() {
    return (
      <div className={`loading-mask ${this.props.isLoading ? 'on' : ''}`}>
        <div className="spinner">
          <img className="rotate" src={loading} alt="loading" />
        </div>
      </div>
    );
  }
}

Loading.displayName = config.displayName;
Loading.propTypes = config.propTypes;
Loading.defaultProps = config.defaultProps;

export default Loading;
